interface CircularProgressWithLabelProps {
  value: number;
  className?: string;
}

const CircularProgressWithLabel: React.FC<CircularProgressWithLabelProps> = ({
  value,
  className = "",
}) => {
  const circumference = 2 * Math.PI * 30; // radius = 30
  const strokeDashoffset = circumference - (value / 100) * circumference;

  return (
    <div
      className={`absolute inset-0 flex items-center justify-center bg-white/50 ${className}`}
    >
      <div className="relative inline-flex">
        <svg className="w-[70px] h-[70px] -rotate-90" viewBox="0 0 70 70">
          <circle
            cx="35"
            cy="35"
            r="30"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
            className="text-gray-200"
          />
          <circle
            cx="35"
            cy="35"
            r="30"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
            strokeDasharray={circumference}
            strokeDashoffset={strokeDashoffset}
            className="text-blue-600"
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-sm font-bold text-red-600">
            {Math.round(value)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export { CircularProgressWithLabel };
